/**
 * @file: useOrderNavigateAwayConfirm.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { useAlert } from '@euler/functions/ux/useAlert';
import { useConfirm } from '@euler/functions/ux/useConfirm';
import { usePersistFn } from '@euler/utils/hooks';
import { noop } from 'rxjs';

export function useOrderNavigateAwayConfirm(callback?: () => void) {
  const { saveDraft, discardDraft, draftEnabled, mode, type } =
    useOrderFlowContext();
  const alert = useAlert();
  const confirm = useConfirm();

  return usePersistFn(() => {
    if (mode === 'update' || type === 'child') {
      confirm({
        title: '确认',
        message: '订单内容已修改，是否确认返回?',
        cancelButtonText: '取消',
        confirmButtonText: '确认',
      })
        .then(confirmed => {
          if (!confirmed) return;
          callback?.();
        })
        .catch(noop);
    } else {
      void alert({
        title: '确认',
        message: '订单内容已修改并已自动存为草稿',
        buttons: [
          {
            text: '保留草稿',
            style: 'default',
            isPreferred: true,
            onPress: () => {
              saveDraft();
              callback?.();
            },
          },
          {
            text: '丢弃草稿',
            style: 'destructive',
            onPress: () => {
              discardDraft();
              callback?.();
            },
          },
          {
            text: '取消',
            onPress: () => {
              draftEnabled.current = true;
            },
          },
        ],
      });
    }
  });
}
